import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import { ChromePicker } from 'react-color';
import { INFO } from '../../../theme';
import { Slider } from './slider';
import { Header, Subheader } from './ui';

const ColorWrapper = styled.div`
  margin: 12px;
  overflow: hidden;
  width: 225px;
`;
const SliderWrapper = styled.div`
  width: 245px;
`;

const StyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

const PillList = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 18px;
`;

const Pill = styled.div`
  padding: 8px 12px;
  color: ${({ selected }) => (selected ? 'white' : INFO)};
  background-color: ${({ selected }) => (selected ? INFO : 'white')};
  border: 1px solid ${INFO};
  border-radius: 3px;
  font-size: 14px;
  text-transform: capitalize;
  margin-right: 4px;
  cursor: pointer;
`;

const mapState = ({ newCustomLayers, customLayersConfig }) => {
  const newLayers = Object.values(newCustomLayers);

  if (!newLayers.length) return {};
  const customLayer = newLayers[0];
  const { styleTypeOptions } = customLayersConfig;
  return {
    styleTypeOptions,
    key: customLayer.key,
    style: customLayer.style,
  };
};

export const ChooseStyle = () => {
  const { key, style, styleTypeOptions } = useSelector(mapState);
  const dispatch = useDispatch();

  const [onChange] = useDebouncedCallback((color, type, opacity) => {
    dispatch({
      type: 'UPDATE_CUSTOM_LAYER_STYLES',
      payload: {
        key,
        type,
        color,
        opacity,
      },
    });
  }, 1000);

  const selectedColor = style.paint[`${style.type}-color`];

  return (
    <StyleWrapper>
      <Header>Pick Layer Styles</Header>
      <Subheader>Pick a treatment</Subheader>
      <PillList>
        {styleTypeOptions.map((styleType) => (
          <Pill
            selected={style.type === styleType}
            key={styleType}
            onClick={() => onChange(selectedColor, styleType, style.opacity)}
          >
            {styleType}
          </Pill>
        ))}
      </PillList>
      <Subheader>Pick a color</Subheader>
      <ColorWrapper>
        <ChromePicker
          color={selectedColor}
          onChange={(color) => onChange(color.hex, style.type, style.opacity)}
          disableAlpha
        />
      </ColorWrapper>
      <Subheader>Transparency</Subheader>
      <SliderWrapper>
        <Slider
          value={Math.ceil((1 - style.opacity) * 100)}
          onChange={(transparency) =>
            onChange(selectedColor, style.type, (100 - transparency) / 100)
          }
        />
      </SliderWrapper>
    </StyleWrapper>
  );
};
